import { z } from 'zod';

export const SHARE_TOKEN_VERSION = 1;
export const REFERRAL_CODE_LENGTH = 8;

export const shareEntityTypeSchema = z.enum(['artist', 'track', 'playlist']);
export type ShareEntityType = z.infer<typeof shareEntityTypeSchema>;

export const shareTokenPayloadSchema = z.object({
  v: z.literal(SHARE_TOKEN_VERSION),
  t: shareEntityTypeSchema,
  id: z.string().min(1),
  d: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  r: z.number().int().positive(),
  ref: z.string().length(REFERRAL_CODE_LENGTH),
  iat: z.number().int().nonnegative(),
});

export type ShareTokenPayload = z.infer<typeof shareTokenPayloadSchema>;
